import { useContext } from 'react';

import { getLagoonTable } from '../../lagoon/lagoonUtil';
import { LagoonContext } from './LagoonContext';

const emptyTable = () => [];

export const useLagoon = (tablePath) => {
  const lagoonContext = useContext(LagoonContext);
  if (lagoonContext && typeof tablePath === 'string' && tablePath) {
    if (!Object.prototype.hasOwnProperty.call(lagoonContext, tablePath)) {
       return emptyTable;
     }
    try {
      const tableAccessor = getLagoonTable(lagoonContext, tablePath);
      return typeof tableAccessor === 'function' ? tableAccessor : emptyTable;
    } catch {
      return emptyTable;
    }
  }

  return lagoonContext;
};
